import { Image } from 'expo-image'
import { useCallback, useState } from 'react'

import { useAppState, useAuth, useNotifications, useRemoveUserPushTokenMutation } from '@/hooks'
import { RevenueCat } from '@/lib'

export const useSignOut = (cb?: () => void): [() => Promise<void>, boolean] => {
  const { expoPushToken } = useAppState()
  const { isSigningOut, signOut: _signOut } = useAuth()
  const { setBadgeCountAsync } = useNotifications()
  const [removeUserPushToken] = useRemoveUserPushTokenMutation()
  const [isCleaningUp, setIsCleaningUp] = useState(false)

  return [
    useCallback(async () => {
      setIsCleaningUp(true)

      try {
        await setBadgeCountAsync(0)
        await RevenueCat.logOut()
        await Image.clearDiskCache()
        await Image.clearMemoryCache()

        if (expoPushToken) {
          await removeUserPushToken(expoPushToken)
        }

        _signOut(cb)
      } finally {
        setIsCleaningUp(false)
      }
    }, [cb, expoPushToken, removeUserPushToken, setBadgeCountAsync, _signOut]),
    // this cleanup all runs before AuthProvider starts its own transition, so isSigningOut on its own leaves the
    // caller with no pending state for the slowest part of signing out
    isCleaningUp || isSigningOut
  ]
}
